import { Page } from '@/core/architecture'

import { PrepaidPointOrdersTemplate } from './template'
import { useViewModel } from './viewModel'

export const PrepaidPointOrders: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <PrepaidPointOrdersTemplate
      state={state}
      onFetchMore={actions.onFetchMore}
    />
  )
}
